(function () {
  'use strict';

  Pager.$inject = ["PATH"];
  app.directive('pager', Pager);

  function Pager(PATH) {
    /**
     * TableView - directive show pagination for table
     *
     * @param  {Object} page - object with pager state info
     * @param  {Object} options - pagination control settings
     * @param  {Number} currentPage - current page
     * @param  {String} sourceType - if server side directive hide button All
     * @param  {Function} goTo - pass to table go to page event
     * @param  {Function} toggleAllMode - pass to table all mode swithc event
     */
    controller.$inject = ["$scope"];
    return {
      scope: {
        page: '=',
        sourceType: '=',
        options: '=',
        goTo: '&',
        toggleAllMode: '&'
      },
      restrict: 'E',
      templateUrl: PATH.components + 'tableView/pager/template.html',
      controller: controller,
      link: link
    };

    function link($scope, $element, $attrs) {
      $scope.$watch('options.currentPage', function (newValue, oldValue) {
        $scope.init();
      });

      $scope.$watch('options.totalCount', function (newValue, oldValue) {
        $scope.init();
      });

      $scope.$watch('options.pageSize', function (newValue, oldValue) {
        $scope.options.currentPage = 0;
        $scope.init();
      });
    }

    function controller($scope) {
      /**
       * init - initialize variables on load
       *
       * @param  {Number} pageNumber: - go to page number
       */
      $scope.goToPage = function (pageNumber) {
        $scope.goTo({ pageNumber: pageNumber });
      };

      /**
       * init - initialize variables on load
       */
      $scope.init = function () {
        var start, end, allMode, pageEnd;
        if (!$scope.options.pageSize || !$scope.options.totalCount || ($scope.options.totalCount < $scope.options.pageSize)) {
          $scope.page = undefined;
          return;
        }

        start = $scope.options.currentPage * $scope.options.pageSize + 1;

        if ($scope.page && $scope.page.allMode) {
          end = $scope.options.totalCount;
          allMode = true;
        } else {
          pageEnd = (($scope.options.currentPage + 1) * $scope.options.pageSize);
          end = $scope.options.totalCount < pageEnd ? $scope.options.totalCount : pageEnd;
        }

        $scope.lastPage = Math.ceil($scope.options.totalCount / $scope.options.pageSize) - 1;

        var pageInfo = {
          allMode: allMode,
          end: end,
          isFirst: $scope.options.currentPage === 0,
          isLast: $scope.options.currentPage === $scope.lastPage,
          name: start + '-' + end + ' of ' + $scope.options.totalCount,
          number: $scope.options.currentPage,
          start: start,
          lastPage: $scope.lastPage,
          pageSize: $scope.options.pageSize
        };

        $scope.page = pageInfo;
      };

      $scope.init();
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/tableView/pager/directive.js